import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Damaged, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from '../skuit/types'

import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[]
  exportFilters?: ExportFilters 
}

export class DamagedAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Damaged>> => {
    const response = await this.api.get('/damages/damaged', config)
    return paginatedTransform(Damaged)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Damaged> => {
    const response = await this.api.post('/damages/damaged', data, config)
    return rawTransform(Damaged)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Damaged> => {
    const response = await this.api.get(`/damages/damaged/${guid}`, config)
    return rawTransform(Damaged)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Damaged> => {
    const response = await this.api.patch(`/damages/damaged/${guid}`, data, config)
    return rawTransform(Damaged)(response.data)
  }

  export = async ({ fields, exportFilters}: ExportProps) => {
    const guid: string | undefined = exportFilters?.guid
    const params = { fields: fields.join(','), products: guid }
    const response = await this.api.axiosInstance({
      url: 'damages/damaged/export',
      params,
      responseType: 'blob'
    })
    fileDownload(response.data, (guid ? `damages_product_${guid}.csv` : 'damages.csv'))
  }
}
